// ======================================================================
// File: frontend/src/modules/ppe/pages/procurement/indent/view/IndentHeaderCard.jsx
// Module: PPE → Procurement → Indent
//
// Purpose:
// - Display indent header summary
// - Supports two layouts:
//     1) page  → gradient ERP header (like list page)
//     2) card  → white summary card (default)
//
// ======================================================================

import React from "react";
import { formatDate } from "../../../../../../utils/formatUtils";

export default function IndentHeaderCard({
  indent,
  variant = "card",
}) {
  // ======================================================
  // PAGE HEADER (GRADIENT STYLE)
  // ======================================================
  if (variant === "page") {
    return (
      <div
        style={{
          background:
            "linear-gradient(90deg, #0f766e 0%, #14b8a6 50%, #5eead4 100%)",
          borderRadius: 12,
          padding: "16px 20px",
          color: "#fff",
          marginBottom: 20,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <h4 style={{ margin: 0 }}>
            Indent : {indent.indent_no}
          </h4>

          <div
            style={{
              fontSize: 13,
              opacity: 0.9,
            }}
          >
            Internal material demand authorization
          </div>
        </div>

        <span
          className={`status-${indent.status}`}
          style={{
            background: "rgba(255,255,255,0.25)",
            color: "#fff",
          }}
        >
          {indent.status}
        </span>
      </div>
    );
  }

  // ======================================================
  // DEFAULT CARD VIEW (WHITE SUMMARY)
  // ======================================================
  return (
    <div className="erp-card">
      <div className="erp-card-header">
        <h3>
          Indent : {indent.indent_no}
        </h3>

        <span
          className={`status-${indent.status}`}
        >
          {indent.status}
        </span>
      </div>

      <div className="erp-card-body grid-4">
        <div>
          <label>Date</label>
          <div>{formatDate(indent.indent_date)}</div>
        </div>

        <div>
          <label>Type</label>
          <div>{indent.indent_type}</div>
        </div>

        <div>
          <label>Source</label>
          <div>{indent.indent_source}</div>
        </div>

        <div>
          <label>Department</label>
          <div>
            {indent.department_name || "-"}
          </div>
        </div>

        <div>
          <label>Required By</label>
          <div>{formatDate(indent.required_date)}</div>
        </div>

        <div>
          <label>Remarks</label>
          <div>
            {indent.remarks || "-"}
          </div>
        </div>
      </div>
    </div>
  );
}
